// Modal Focus Management for Foundation Reveal (modals on most of the app)
// Handles focus trapping and focus return for all Foundation Reveal modals
// (e.g. CSSP Summary modal, appointments modal on /calendars, resea calendar)

import { getFocusable, attachFocusTrap } from '../utils/focus_trap';

$(document).ready(() => {
  let triggerElement = null;
  let focusTrapCleanup = null;

  // Allows focus to return to the original trigger
  $(document).on('click', '[data-open], [data-toggle], button, a', (e) => {
    const isCloseButton = e.currentTarget.hasAttribute('data-close');
    const isInsideModal = e.currentTarget.closest('[data-reveal]') !== null;

    if (!isCloseButton && !isInsideModal) {
      triggerElement = e.currentTarget;
    }
  });

  // Remember opener for keyboard activation on controls using [data-open].
  $(document).on('keydown', '[data-open]', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.currentTarget.closest('[data-reveal]')) return;
    triggerElement = e.currentTarget;
  });

  // When modal closes: remove focus trap and return focus to trigger element
  $(document).on('closed.zf.reveal', '[data-reveal]', () => {
    if (focusTrapCleanup) {
      focusTrapCleanup();
      focusTrapCleanup = null;
    }

    if (triggerElement && triggerElement.focus) {
      setTimeout(() => {
        triggerElement.focus();
      }, 100);
    }
  });

  // When modal opens: set up focus trap and focus first element
  $(document).on('open.zf.reveal', '[data-reveal]', function onOpenReveal() {
    const modal = this;

    focusTrapCleanup = attachFocusTrap(modal);

    setTimeout(() => {
      const focusableElements = getFocusable(modal);
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }, 100);
  });
});
